import ButtonTemplate from '@ui/Button/Button';
import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';
import { breakpoints, theme } from '../../styles/theme';

export const Wrapper = styled.div`
    position: relative;
    padding: ${rem(20)} 0;
`;

export const Main = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;

export const PicWrapper = styled.div`
    margin: ${rem(15)};
    width: 80%;

    @media (min-width: ${breakpoints.md}px) {
        width: 40%;
    }
    @media (min-width: ${breakpoints.lg}px) {
        width: 30%;
    }
`;

export const PicSource = styled.img`
    width: 100%;
    cursor: pointer;
    border-radius: ${rem(14)};
`;

export const Background = styled.div`
    width: 100%;
    height: ${rem(300)};
    top: 0;
    left: 0;
    background: rgba(116, 120, 129, 0.08);
    position: absolute;
    z-index: -999;

    @media (min-width: ${breakpoints.sm}px) {
        height: ${rem(500)};
    }
`;

export const Video = styled.div`
    width: 100%;
    padding: ${rem(10)} 0 ${rem(45)} 0;
    margin: 0 auto ${rem(40)} auto;

    @media (min-width: ${breakpoints.sm}px) {
        width: 80%;
    }
`;

export const Player = styled.video`
    width: 100%;
    border-radius: ${rem(14)};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

export const Title = styled.h3`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h3};
    width: 100%;
    text-align: center;
    margin-top: ${rem(50)};
    margin-bottom: ${rem(20)};
`;
